import React, { useEffect, useRef, useState, useCallback } from "react";
import { Alert, Form } from "reactstrap";

// components
import StartButtons from "./StartButtons";
import InputSection from "./InputSection";
import EndButtons from "./EndButtons";
import MoreMenu from "./MoreMenu";
import Reply from "./Reply";
import { v4 as uuidv4 } from 'uuid';
import heic2any from "heic2any";


// interface
import { MessagesTypes } from "../../../../data/messages";
import { useSignalR } from "../../../../../src/components/SignalRContext";
import { MessageTypes, ChatsActionTypes } from "../../../../redux/chats/types";
import { useRedux } from "hooks";
import { createSelector } from "reselect";
import { getPushHistoryLocal, Profile2ActionTypes } from "../../../../redux/profile2/p2_reducer";
import { Utils } from "helpers/utils";

import { chatsApiResponseSuccess, setTypingText } from "../../../../redux/chats/actions";
import { utils } from "prettier/doc";
import { UAParser as UA } from 'ua-parser-js';
import ImageCapture from "./ImageCapture";
import { Const } from "const";
import QuickReply from "./QuickReply";
import LightBox2 from "components/LightBox2";
import { DbUtils } from "helpers/dbUtils";


interface IndexProps {
  onSend: (data: any) => void;
  replyData: null | MessagesTypes | undefined;
  onSetReplyData: (reply: null | MessagesTypes | undefined) => void;
  chatUserDetails: any;
}

// Selector to get the typing text for a specific chat ID
// export const selectTypingTextByChatId = (state:any, selectedChatId:any) => {
//   const entry = state.Chats.typingText.find(
//     (item:any) => item.selectedChat === selectedChatId
//   );
//   return entry ? entry.text : ''; // Return empty string if no entry is found
// };

const Index = ({ onSend, replyData, onSetReplyData, chatUserDetails, }: IndexProps) => {

  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state: any) => state.Layout,
    (state: any) => state.Chats,
    (layout, chats) => {
      const selectedChat = chats.selectedChat;
      const chatUserDetails_id = chats.chatUserDetails.id;
      const memberIdInChatRoom = chats.chatUserDetails.memberId;
      const typingText = chats.typingText.find(
        (item: any) => item.selectedChat == selectedChat
      )?.typingText || ''; // Find the text for the selected chat or return an empty string

      const tagNames = chats.typingText.find(
        (item: any) => item.selectedChat == selectedChat
      )?.tagNames || ''; // Find the text for the selected chat or return an empty string


      // console.log({selectedChat, typingText}, chats.typingText);

      return {
        chatConnectError: layout.chatConnectError,
        selectedChat, // Keep the selected chat ID
        typingText, // Add the typing text for the selected chat
        tagNames,
        chatUserDetails_id,
        memberIdInChatRoom // 20250716 member id in room, if null mean user is not in room (may be observer)
      };
    }
  );


  const { chatConnectError, selectedChat, typingText, tagNames, chatUserDetails_id, memberIdInChatRoom } = useAppSelector(storeData);

  //  console.log('selectedChat:', selectedChat + '=' + (typingText ?? 'no text'));

  /*
  more menu collapse
  */
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isOpenQuickReply, setIsOpenQuickReply] = useState<boolean>(false);

  const onSendQuickReplyDone = () => {
    setIsOpenQuickReply(false);
  }

  const onToggle = () => {
    setIsOpen(!isOpen);
    setemojiArray(true);
  };

  const onClickQuickReply = () => {
    setIsOpenQuickReply(e => !e);
  }

  /*
  disable send button
  */
  const [disabled, setDisabled] = useState<boolean>(true);

  const debounceDispatch = useCallback(() => {
    let timer: NodeJS.Timeout;

    return (selectedChat: any, value: string) => {
      if (timer) clearTimeout(timer);

      timer = setTimeout(() => {
        dispatch(setTypingText(selectedChat, value));
      }, 500); // Adjust the debounce time as needed
    };
  }, [dispatch]);
  const debouncedSetTypingText = debounceDispatch();

  /*
  input text
  */
  const [text, setText] = useState<null | string>("");
  const [rowCount, setRowCount] = useState<number>(1);
  const onChangeText = (value: string) => {
    //console.log('onChangeText:' + value);
    setText(value);
    // dispatch(setTypingText(selectedChat, value));
    debouncedSetTypingText(selectedChat, value);
  };

  useEffect(() => {
    setText(typingText);
    setImages(null); //console.log('clear image');
    setClipboardImages([]);
    setFiles(null); //console.log('clear file');

  }, [selectedChat]);


  /*
  images
  */
  const [images, setImages] = useState<Array<any> | null | undefined>();
  const onSelectImages = (images: Array<any>) => {
    setImages(images); //console.log('set image:', images);
  };

  /*
  files
  */
  const [files, setFiles] = useState<Array<any> | null | undefined>();
  const onSelectFiles = async (files: Array<any>) => {
    try {
      // Convert FileList to an array so we can use Array methods
      const fileArray = Array.from(files);
      let attached = new Array<any>;

      // fileArray.forEach((file) => {
      for (const fileOrg of fileArray) {
        // Check if the file is an image by its MIME type
        // console.log('file.type = ' + file.type);
        const isImageFile = Utils.IsImageFile(fileOrg.name, fileOrg.type);
        if (isImageFile) {// file.type.startsWith('image/')) {
          let blobUrl = "";
          const isHeic = fileOrg.name.toLowerCase().endsWith(".heic");
          let newFile = null;
          if (isHeic) {
            try {
              const convertedBlob = await heic2any({
                blob: fileOrg,
                toType: "image/jpeg",
                quality: 0.8,
              });
              // Create a new File object with a .jpg name
              newFile = new File(
                [convertedBlob as Blob],
                fileOrg.name.replace(/\.heic$/i, ".jpg"),
                { type: "image/jpeg" }
              );
              blobUrl = URL.createObjectURL(newFile);//convertedBlob as Blob);
            } catch (ex2) {
              alert('ไม่รอบรับไฟล์ .heic');
            }
          } else {
            blobUrl = URL.createObjectURL(fileOrg);
          }
          // const blobUrl = URL.createObjectURL(file);
          if (blobUrl) {
            console.log('blobUrl = ' + blobUrl);
            setClipboardImages((prevImages) => [
              ...prevImages,
              { blobUrl, file: newFile ?? fileOrg, index: prevImages.length },
            ]);
          }
        } else {
          attached.push(fileOrg);
        }
      };

      if (attached.length > 0) {
        setFiles(attached);
      }
    } catch (e) {
      console.error(e);
      alert((e as any).message);
    }
    // console.log('onSelectFiles:', files);
    // setFiles(files); //console.log('set file:', files);
  };
  useEffect(() => {
    if (text || images || files) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [text, images, files]);

  // emoji picker 
  const [emojiArray, setemojiArray] = useState<any>("");
  const [emojiPicker, setemojiPicker] = useState<boolean>(false);
  const onEmojiClick = (event: any) => {
    setemojiArray([...emojiArray, event.emoji]);
    setText(text + event.emoji);
  };

  const { sendMessage } = useSignalR(); // Use the custom hook
  const sendMessageSignalR = async (data: any) => {
    // console.log('sendMessageSignalR:', data);
    const isText = data.text && data.text.trim() !== "";
    const isAttached = data.attachments && data.attachments.length > 0;
    const isEmpty = !(isText || isAttached);
    // console.log('sendMessageSignalR [Empty = ' + isEmpty + ']');
    if (!isEmpty) {
      if (data.text == Profile2ActionTypes.GET_PUSH_HISTORY_LOCAL) {
        try {
          alert('Canncel this function');
          // const data = await Utils.GetDbDataByPrefix("push.");
          // const messages = [];
          // for (let i = 0; i < data.length; ++i) {
          //   messages.push(
          //     {
          //       mId: data[i].msgId,
          //       text: 'You got push notification of message\n' + data[i].msgId + '\n' + data[i].title + '\n' + data[i].body,
          //       senderId: -1,
          //       isFromMe: false,
          //       senderName: "BOT",
          //       senderPictureUrl: "/icons/chatbot.png",
          //       time: Utils.GetCurrentDateTimeLongFormat(),
          //       "meta": {
          //         "receiver": -1,
          //         "sender": -1,
          //         "senderName": "BOT",
          //         "sent": true,
          //         "received": true,
          //         "read": true,
          //         "isForwarded": false,
          //         "userData": {
          //           "userId": 0,
          //           "userType": 0,
          //           "isAdmin": false,
          //           "firstName": "hahahah",
          //           "lastName": "jigjig",
          //           "pictureUrl": "/icons/chatbot.png",
          //           "profileImage": "/icons/chatbot.png",
          //           "isActive": true,
          //           "chats": [],
          //         }
          //       }
          //     }
          //   );
          // }
          // const data2 = {
          //   conversationId: -1,
          //   userId: -1,
          //   messages: messages
          // };
          // if (data.length <= 0) {
          //   alert('Not have push store in your local db');
          // } else {
          //   dispatch(chatsApiResponseSuccess(ChatsActionTypes.GET_CHAT_USER_CONVERSATIONS, data2));
          // }
        } catch (ex1) {
          alert((ex1 as Error).message);
        }
      } else if (data.text == Profile2ActionTypes.DEL_PUSH_HISTORY_LOCAL) {
        await DbUtils.DeleteDbDataByPrefix("push.");
        alert('Cleared');
      } else {
        try {
          // Send message through SignalR
          //console.log(chatUserDetails);
          if (sendMessage) {
            data.Uid = uuidv4();
            data.SendToId = chatUserDetails.id;
            data.replyToMsgId = data.replyOf?.mId;
            // console.log('data send sigr:', data);
            const rs = await sendMessage(data);
            if (rs != "") {
              alert('ส่งข้อความไม่ได้เพราะ<br/><span class="text-red">' + rs + '</span><br/>กรุณาส่งใหม่');
            }
          } else {
            //console.log('function send message is nothing');
          }
          // setNewMessage("");
        } catch (error) {
          //console.log('SignalR - Send Error :', error);
          // console.error("Error sending message: ", error);
        }
      }
    }
  };

  const getAllAttachForSend = () => {
    const fileUpload = files ? files.map((file) => file) : [];
    const imgClipboard = clipboardImages ? clipboardImages.map((clip) => clip.file) : [];
    return [...fileUpload, ...imgClipboard];
  };

  // Submit Message
  const onSubmit = () => {
    // alert('submit');
    // console.log('tagNames = ' + tagNames);
    let data: any = {};
    if (text) {
      data["text"] = text;
    }
    data["tagNames"] = tagNames;
    // console.log('getBlobUrls:', getBlobUrls());
    // console.log('images:', images);
    // console.log('files:', files);
    // console.log('clipboardImages:', clipboardImages);
    if (images && images.length) {
      const imgs = (images || []).map((i: any, key: number) => {
        const src = URL.createObjectURL(i);
        return {
          id: key + 1,
          downloadLink: src,
        };
      });
      data["image"] = imgs;
    }

    // console.log('files:', files);
    // console.log('clipboardImages:', clipboardImages);
    // console.log('getAllAttachForSend:', getAllAttachForSend());
    const allFileToSend = getAllAttachForSend();

    if (allFileToSend && allFileToSend.length) {//if (files && files.length) {
      const fs = (allFileToSend || []).map((f: any, key: number) => {
        const src = URL.createObjectURL(f);
        return {
          id: key + 1,
          name: f.name,
          downloadLink: src,
          desc: f.size,
        };
      });
      data["attachments"] = fs;
    }
    data.replyOf = replyData;
    //console.log('data to send:', data);

    setText("");
    setImages(null); //console.log('clear image');
    setClipboardImages([]);
    setFiles(null); //console.log('clear file');
    setemojiPicker(false);
    data.messageType = MessageTypes.NewMessage;
    if (data.text || data.image || data.attachments) {
      sendMessageSignalR(data);
    }

    // console.log('send message:', data);
    onSend(data);
    if (inputRef.current) {
      inputRef.current.focus();
    }
    setRowCount(1);

    dispatch(setTypingText(selectedChat, ""));
    debouncedSetTypingText(selectedChat, "");
  };

  useEffect(() => {
    if (replyData && inputRef.current) inputRef.current.focus();
  }, [replyData]);

  const onClearMedia = () => {
    setImages(null); //console.log('clear image');
    setClipboardImages([]);
    setFiles(null); //console.log('clear file');
  };


  const [isPC, setIsPC] = useState<boolean>(true);

  useEffect(() => {
    try {
      const parser = new UA();
      const deviceType = parser.getDevice().type;
      setIsPC(!deviceType);
    } catch (e) {
      console.error(e);
    }
  }, []);
  const isPC2 = Utils.IsDesktop();

  const inputRef = useRef<HTMLTextAreaElement | null>(null);

  const onKeyDown = (e: any) => {
    // console.log('onKeyDown:', e);
    if (e.key === 'Enter') {
      if (isPC2/*isPC*/) {
        if (e.shiftKey) {
          setText((prev) => prev + "\n");
          setRowCount((prev) => prev + 1);
          e.preventDefault();
        } else {
          e.preventDefault();
          onSubmit();
        }
      } else {
        setRowCount((prev) => prev + 1);
      }
    }
  }

  // const errText = chatConnectError
  //   ? chatConnectError
  //   : (!chatUserDetails_id
  //     ? "ไม่มีข้อมูลห้องแชท"
  //     : ""
  //   );
  const errText = chatConnectError
    ? chatConnectError
    : (!chatUserDetails_id
      ? "ไม่มีข้อมูลห้องแชท"
      : (memberIdInChatRoom ? "" : "OBSERVER MODE")
    );



  const [clipboardImages, setClipboardImages] = useState<{ blobUrl: string; file: File; index: number }[]>([]);

  const handleInputPaste = (event: React.ClipboardEvent<HTMLTextAreaElement>) => {
    const clipboardItems = event.clipboardData.items;

    for (let i = 0; i < clipboardItems.length; i++) {
      const item = clipboardItems[i];
      if (item.type.startsWith("image/")) {
        if (clipboardImages.length >= Const.MAX_CLIPBOARD_IMAGE_FOR_SEND) {
          alert('จำนวนรูปจากการคัดลอก เกินกว่าที่กำหนด');
        } else {
          const file = item.getAsFile();
          if (file) {
            const blobUrl = URL.createObjectURL(file);
            // Add to the array of images with blobUrl, file, and index
            setClipboardImages((prevImages) => [
              ...prevImages,
              { blobUrl, file, index: prevImages.length },
            ]);
            // console.log(blobUrl);
            // setImageUrl(blobUrl);
            // setImageFile(file);
          }
        }
      }
    }
  };

  const onRemoveImage = (index: number) => {
    try {
      setClipboardImages((prevImages) => prevImages.filter((image) => image.index !== index));
    } catch (e) {
      alert((e as any).message);
    }
  }

  return (
    <div className="chat-input-section p-3 p-md-4">
      <Form
        id="chatinput-form"
        onSubmit={(e: any) => {
          e.preventDefault();
          onSubmit();
        }}
      >
        {/* {chatConnectError && (
          <div className="alert alert-danger fade show global-error text-center" role="alert">
            <span dangerouslySetInnerHTML={{ __html: chatConnectError }} />
          </div>
        )} */}

        {errText && (
          <div className="alert alert-danger fade show global-error text-center" role="alert">
            <span dangerouslySetInnerHTML={{ __html: errText }} />
          </div>
        )}


        {!errText && (
          <div className="row g-0 align-items-center">
            <div className="col-auto ">
              <StartButtons
                onToggle={onToggle}
                onEmojiClick={onEmojiClick}
                setemojiPicker={setemojiPicker}
                emojiPicker={emojiPicker}
                onSelectFiles={onSelectFiles}
                onClickQuickReply={onClickQuickReply}
              />
            </div>
            <div className="col ">
              <InputSection ref={inputRef} value={text} onChange={onChangeText} onKeyDown={onKeyDown} onPaste={handleInputPaste} rowCount={rowCount} />
            </div>
            <div className="col-auto">
              <EndButtons onSubmit={onSubmit} disabled={disabled} />
            </div>
          </div>
        )}

      </Form>

      {(images && images.length) || (files && files.length) ? (
        <Alert
          isOpen={true}
          toggle={onClearMedia}
          color="secondary"
          className="alert-dismiss-custom rounded-pill font-size-12 mb-1 selected-media"
          closeClassName="selected-media-close"
        >
          <p className="me-2 mb-0">
            {images && !files && ` You have selected ${images.length} images`}
            {files && !images && ` You have selected ${files.length} files`}
            {files &&
              images &&
              ` You have selected ${files.length} files & ${images.length} images.`}
          </p>
        </Alert>
      ) : null}

      <MoreMenu
        isOpen={isOpen}
        onSelectImages={onSelectImages}
        onSelectFiles={onSelectFiles}
        onToggle={onToggle}
      />

      <ImageCapture
        // isOpen={isOpen}
        // onSelectImages={onSelectImages}
        // onSelectFiles={onSelectFiles}
        // onToggle={onToggle}      
        images={clipboardImages}
        onRemoveImage={onRemoveImage}
      />

      <QuickReply isOpen={isOpenQuickReply} onSendDone={onSendQuickReplyDone} />

      {/* <LightBox2 isOpen={true}
        images={[{
          fileId: "1",
          downloadLink: "https://localhost:7136/_uploadqck/pic/159/A02.JPG"
        }]}
        onClose={() => { }} defaultIdx={1}></LightBox2> */}

      <Reply
        reply={replyData}
        onSetReplyData={onSetReplyData}
        chatUserDetails={chatUserDetails}
      />
    </div >
  );
};

export default Index;
